// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["dist/styles/main"], () => (__webpack_require__("./assets/scripts/main.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["dist/styles/main"], () => (__webpack_require__("./assets/styles/main.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
